/** @jsx jsx */
import { jsx, Flex, Box, Styled, Divider, Link } from "theme-ui"
// import { GitHub } from "react-feather"

import Contact from "./Contact"
import Projects from "./Projects"
import Footer from "./Footer"
import { LinkStyle } from "../utils/styles"

const SectionTitle = ({ title }) => (
  <div>
    <Styled.h6 sx={{ marginTop: 5, marginBottom: 1 }}>{title}</Styled.h6>
    <Divider sx={{ marginBottom: 4 }} />
  </div>
)

const ExtLink = ({ href, children }) => (
  <Link href={href} sx={LinkStyle} target="__blank">
    {children}
  </Link>
)

export default function HomePage() {
  return (
    <div
      sx={{
        width: ["90%", "80%", "60%"],
        margin: "auto",
        paddingTop: [2, 5, 5],
      }}
    >
      <Flex sx={{ justifyContent: "space-between" }}>
        <Box sx={{ width: ["100%", "70%", "70%"], paddingTop: 4 }}>
          <Contact resp={true} />
          <Styled.h1
            sx={{
              // display: ["none", "block", "block"],
              margin: 0,
              fontWeight: "400",
            }}
          >
            Pranay Jain
          </Styled.h1>
          <SectionTitle title="BACKGROUND" />
          <Styled.p>
            I am a recent undergraduate from the University of British Columbia
            where I studied Computer Science and Mathematics. My research
            interests lie at the intersection of Algorithmic Game Theory and
            Artificial Intelligence. I currently work at the UBC{" "}
            <ExtLink href="https://www.cs.ubc.ca/cs-research/lci">
              Lab for Computational Intelligence
            </ExtLink>
            , where I'm fortunate to be advised by{" "}
            <Link href="https://www.cs.ubc.ca/~kevinlb/" sx={LinkStyle}>
              Kevin Leyton-Brown
            </Link>
            .
          </Styled.p>
          <Styled.p>
            I've previous experience as a full-stack software developer and have
            worked with a few startups to build their products. Some of them
            include <ExtLink href="https://dapperlabs.com">Dapper Labs</ExtLink>,{" "}
            <ExtLink href="https://collabware.com/">Collabware</ExtLink>,{" "}
            <ExtLink href="http://vitay.io/">Vitay</ExtLink> and{" "}
            <ExtLink href="http://featherx.ai">FeatherX</ExtLink>.
          </Styled.p>

          <Box sx={{ marginY: 5 }}>
            <SectionTitle title="RESEARCH" />
            My current research relates to the{" "}
            <ExtLink href="https://www.fcc.gov/about-fcc/fcc-initiatives/incentive-auctions">
              FCC Incentive Auction{" "}
            </ExtLink>
             that was designed to reallocate radio spectrum from less to more valuable uses. My work focusses on creating a generative model that produces instances of auction settings using little historical data. An 'auction setting' is a set of inputs needed for describing the results of an auction beyond the auction’s rules. In the case of spectrum auctions, this can be represented in the form of a constraint graph that models the spatial distribution of bidders and possible constraints on allocations. I've developed a generative model that produces such auction settings and can be used for benchmarking and comparing auction designs empirically.
            
          </Box>

          <Box sx={{ marginY: 5 }}>
            <SectionTitle title="SELECTED PROJECTS" />
            <Projects />
          </Box>
        </Box>
        <Contact resp={false} />
      </Flex>
      <Footer />
    </div>
  )
}
